module.exports = __webpack_public_path__ + "img/query.56419d3b.jpg";